//REACT IMPORTS
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { BrowserRouter } from 'react-router-dom';
import { GoogleReCaptchaProvider as GoogleReCaptcha } from 'react-google-recaptcha-v3';
import App from './App';
import { handleSessionExpired, isSessionInvalidResponse } from './services/sessionExpiration';
import RecaptchaBinder from './components/helpers_components/RecaptchaBinder';

//CSS IMPORTS
import './index.css';

import * as serviceWorker from './serviceWorker';

// Red de seguridad global: cualquier respuesta de sesión invalidada (`data.clean`),
// incluidas las peticiones que no pasan por las clases Request,
// dispara el cierre controlado. `handleSessionExpired` es idempotente, así que
// no interfiere con el manejo que ya hacen las clases.
axios.interceptors.response.use(
  (response) => {
    const body = response && response.data && response.data.data;
    if (isSessionInvalidResponse(body)) {
      handleSessionExpired();
    }
    return response;
  },
  (error) => {
    const body = error && error.response && error.response.data && error.response.data.data;
    if (isSessionInvalidResponse(body)) {
      handleSessionExpired();
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <GoogleReCaptcha reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}>
    <RecaptchaBinder />

    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleReCaptcha>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
